<ng-template #branch let-item="item">
  <div >
    <div class="d-flex flex-direction-row branch-list">
      <mat-checkbox
        (change)="selectBranch(item, $event)"
        [indeterminate]="item.indeterminate"
        [checked]="item.checked">
          {{item.label}}
      </mat-checkbox>
      <div class="w-100 text-right cursor-pointer" (click)="toggleBranch(item, $event)">
        <mat-icon [svgIcon]="item.collapsed ? 'deloitte-ai-plus' : 'deloitte-ai-minus'"></mat-icon>
      </div>
    </div>
      <ng-container *ngIf="item.children.length && !item.collapsed" [ngTemplateOutlet]="checkboxList" [ngTemplateOutletContext]="{source: item.children}">
      </ng-container>
    </div>
</ng-template>

<ng-template #leaf let-item="item">
  <mat-checkbox [checked]="item.checked" (change)="toggleLeaf(item)">
      {{item.label}}
  </mat-checkbox>
</ng-template>

<ng-template #checkboxList let-source="source">
  <ul>
    <li *ngFor="let item of source">
      <ng-container
        [ngTemplateOutlet]="item.children ? branch : leaf"
        [ngTemplateOutletContext]="{item: item}">
      </ng-container>
    </li>
  </ul>
</ng-template>

<ng-container [ngTemplateOutlet]="checkboxList" [ngTemplateOutletContext]="{source: root.children}">
</ng-container>
